import React, { useContext } from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import defaultBlog from "../../../../../assets/images/defaultBlog.png";
import useStyles from "./styles";
import { WebContext } from "../../../../../Utility";
import { useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import Carousel from "../../../../Commons/carousel";
import Divider from "@material-ui/core/Divider";
import CarouselDesktop from "../../../Commons/slider";
export default () => {
  const theme = useTheme();
  const websiteData = useContext(WebContext);
  const classes = useStyles();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(1280));
  const isSmallScreen1 = useMediaQuery(theme.breakpoints.down(511));
  let {
    articles: filteredPages = [],
    username = "",
    deskTopView = true,
  } = websiteData;

  const getArticleItem = ({
    id,
    title = "",
    image_url = "",
    summary = "",
    slug_url = "",
  }) => (
    <Box
      className={classes.articleCard}
      style={{
        backgroundColor: theme.agentTheme.card.main,
        maxWidth: !deskTopView ? "100%" : "340px",
        width: "100%",
        height: "430px",
        marginBottom: "1rem",
        marginRight: deskTopView && "1rem",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        borderRadius: "4px",
        cursor: "pointer",
      }}
    >
      <Box
        className={classes.articleImage}
        style={{
          height: !deskTopView ? "200px" : "150px",
          width: "100%",
          backgroundImage: `url(${image_url ? image_url : defaultBlog})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Box
        style={{
          padding: "16px",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          className={classes.articleTitle}
          style={{ color: theme.agentTheme.card.foreground }}
        >
          {title}
        </Typography>

        {summary && (
          <Typography
            className={classes.articleSummary}
            style={{
              color: theme.agentTheme.card.secondary_foreground,
              display: "-webkit-box",
              WebkitLineClamp: 5,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              lineHeight: "1.5em",
              maxHeight: `${1.5 * 5}em`,
            }}
          >
            {summary}
          </Typography>
        )}
        <Box style={{ marginTop: "auto" }}>
          <Divider
            style={{
              backgroundColor: theme.agentTheme.card.foreground,
              marginBottom: "8px",
              opacity: "0.2",
            }}
          />
          <Typography
            style={{
              color: theme.agentTheme.primary.main,
              float: "right",
              textTransform: "uppercase",
            }}
            fullWidth
            onClick={() => {
              window.open(
                `/${username ? `${username}/` : ""}pages/${slug_url}`
              );
            }}
          >
            Read More
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      {filteredPages.length > 0 && (
        <Box className={classes.mainBox} id="blogs">
          <Box className={classes.maxWidth}>
            {deskTopView ? (
              <Box
                display="flex"
                margin={"auto"}
                maxWidth={1216}
                flexDirection="column"
                width="100%"
              >
                <CarouselDesktop
                  shiftBy={1}
                  getTestimonialItem={getArticleItem}
                  items={filteredPages}
                  showArrowParadise={false}
                  itemsPerCarousel={isSmallScreen ? 2 : 3}
                  itemWidthPx={380}
                  toorThemeStepper={true}
                  title="Our Blog"
                  text="From culture to convenience, we share it all. Your guide to stress-free and enjoyable journeys."
                />
              </Box>
            ) : (
              <Box
                display="flex"
                margin={"auto"}
                maxWidth={isSmallScreen1 ? "250px" : "400px"}
                flexDirection="column"
                width="100%"
              >
                <Carousel
                  getTestimonialItem={getArticleItem}
                  items={filteredPages}
                  itemsPerCarousel={1}
                  deskTopView={deskTopView}
                  toorThemeStepper={true}
                  showStepper={false}
                  title="Our Blog"
                  text="From culture to convenience, we share it all. Your guide to stress-free and enjoyable journeys."
                />
              </Box>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};
